"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
require("../icon");
//@ts-ignore
require("../theme.ts");
omi_1.define('m-toast', (_a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function (props) {
            var cls = omi_1.extractClass(props, 'm-toast');
            var type = props.type, show = props.show, children = props.children, iconSize = props.iconSize, others = __rest(props, ["type", "show", "children", "iconSize"]);
            return (omi_1.h("div", { style: { display: show ? 'block' : 'none' } },
                omi_1.h("div", __assign({}, cls, others),
                    omi_1.h("i", { class: "icon" },
                        omi_1.h("svg", __assign({ viewBox: "0 0 1024 1024" }, omi_1.extractClass({}, {
                            'rotate': props.rotate
                        }), { width: "3em", height: "3em", fill: "white", "aria-hidden": "true" }),
                            omi_1.h("path", { d: props.path })),
                        omi_1.h("div", { style: "color: white;" })),
                    omi_1.h("p", { class: "m-toast_content" }, children))));
        };
        return class_1;
    }(omi_1.WeElement)),
    _a.defaultProps = {
        show: false
    },
    _a.css = css,
    _a));
var toast = {}, dom;
toast.showLoading = function (text) {
    if (dom) {
        document.body.removeChild(dom);
    }
    dom = omi_1.render(omi_1.h("m-toast", { path: 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z', rotate: true, show: true }, text || '加载中'), 'body');
};
toast.hideLoading = function () {
    if (dom) {
        document.body.removeChild(dom);
        dom = null;
    }
};
toast.show = function (_a) {
    var path = _a.path, text = _a.text, rotate = _a.rotate;
    if (dom) {
        document.body.removeChild(dom);
    }
    dom = omi_1.render(omi_1.h("m-toast", { show: true, rotate: rotate, path: path }, text || ''), 'body');
};
toast.hide = toast.hideLoading;
exports.default = toast;
